import { render, staticRenderFns } from "./EditSpecifiedReportModal.vue?vue&type=template&id=2ba54bb2&scoped=true&"
import script from "./EditSpecifiedReportModal.vue?vue&type=script&lang=ts&"
export * from "./EditSpecifiedReportModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditSpecifiedReportModal.vue?vue&type=style&index=0&id=2ba54bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba54bb2",
  null
  
)

export default component.exports